import React from "react";
import Image from "next/image";

interface ImageProps {
  url: string;
  width?: number;
  height?: number;
}

const CardImage: React.FC<ImageProps> = ({ url, width = 500, height = 300 }) => (
  <Image src={url} alt="Image" width={width} height={height} />
);

export default CardImage;
